<div class="landing-image-container">
    <div class="landing-text">
    <h1 class="header text-3xl">{{"welcomeTitle" | translate}}</h1>
    <!-- <h5 class="subheader text-lg">{{"subTitle" | translate}}</h5> -->
    </div>
     <!-- <img width="100%" height="360px" class="landing-img" src="../../../../assets/images/feature/UK-landing-img.png" 
     alt="UK landing image" /> -->
       
  </div>
  <div class="user-card-container">
    <div  class="d-flex flex-column flex-sm-row user-cards align-items-stretch justify-content-between">
      <div *ngFor = "let usercard of userCards" class="col-md user-card justify-content-center d-flex align-items-center">
        <a class="card-padding" *ngIf="!usercard?.navigate" (click)="usercardClicked(usercard)"  routerLinkActive="router-link-active">
          <span class="feature-icon"><img height="90" width="90" [src]="'../../../../assets/images/feature/' + usercard?.icon" alt="duns-enquiry-icon" /></span>
          <span class="text-color user-card-title text-xl">{{usercard.title | translate}}</span>
        </a>
        <a class="card-padding" *ngIf="usercard?.navigate" [href]="usercard?.navigate" target="_blank" rel="noopener noreferrer">
          <span class="feature-icon"><img height="90" width="90" [src]="'../../../../assets/images/feature/' + usercard?.icon" alt="duns-enquiry-icon" /></span>
          <span class="text-color user-card-title text-xl">{{usercard.title | translate}}</span>
        </a>
      </div>
    </div>
  </div>
  <div class="credibility justify-content-center text-center align-items-center">
    <div>
      <p class="credibility-concierge justify-content-center align-items-center">
        <img height="40" width="40" [src]="'../../../../assets/images/feature/' + countryData?.landingPageDetails?.navigationIcon" class="look-up-icon-black.svg" alt="duns-lookup-icon" />
        <span class="text-lg m-l-10">{{"navigationHeading" | translate}}</span>
      </p>
      <div class="credibility-concierge-second margin-top-20 justify-content-center align-items-center">
        <span class="margin-top-20 text-xl user-card-title">
          <a
            [href]="countryData?.landingPageDetails?.navigationUrl"
            target="_blank" rel="noopener noreferrer" class="credibilitybutton" aria-label="Find out more, opens in a new window">
          {{"clickHere" | translate}}
        </a>
      </span>
    </div>
      
    </div>
  </div>
  
  <!-- <ng-template #template>
    <div class="modal-body">
      <div>
        <button type="button" class="close pull-right" aria-label="Close">
          <span aria-hidden="true">×</span>
        </button>
      </div>
      <div class="row">
        <div class="col-sm-12 col-md-6 pl-3 pr-3 divider">
          <div class="p-0">
          <div class="text-3xl sign-in-title mt-2">Existing User</div>
          <p class="text-md pt-3 mb-0 pl-0 popover-content login-text-color">
            If you have registered on our site before or have access to any D&B products, you can use your existing login credentials.
          </p>
          <button
          type="button"
          class="btn btn-primary btn-height mt-2 mb-3"
        >
          Log In
        </button>
        </div>
        </div>
        <div class="col-sm-12 col-md-6 pl-4 pr-3">
          <div class="p-0">
            <div class="text-3xl sign-in-title mt-2">New User</div>
            <p class="text-md pt-3 mb-0 pl-0 popover-content login-text-color">
             
        If you do not have access to any D&B products or this is your first time using our site, please click the <strong class="text-lg">Create User</strong>  button to get started
            </p>
              <button
                type="button"
                class="btn btn-primary btn-height mt-2 mb-3" 
              >
                Create User
              </button>
          </div>
        </div>
      </div>
    </div>
  </ng-template> -->
    <!-- <app-helpful-links [channelMapDataHelfulLink]="helpfulLinksList"></app-helpful-links> -->